<template>
  <div class="as-incident-list__player as-d-flex as-flex-1">
    <div class="as-incident-list__player-info as-d-flex as-align-items-center">
      <div class="as-incident-list__player-logo as-cursor-pointer">
        <img
          class="as-rounded-pill as-incident-list__player-logo--in as-player-avatar as-bg-white"
          :src="img || getImgUrlBySport('player', 'default', true, 'football')"
          :alt="name"
        />
      </div>
    </div>
    <div class="as-incident-list__player-name as-d-flex as-flex-column">
      <span>{{ name }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  name?: string;
  img?: string;
}

const props = withDefaults(defineProps<Props>(), {
    name: 'N/A',
});
</script>
<script lang="ts">
export default {};
</script>
